import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';
import SearchEventListImpl from './search-event-list.js';

const { UIView } = MojitoCore.Presentation;

/**
 * Renders the event cards of the search discovery overlay. The same list shows the main events of
 * the day before a query is entered, and the matching events once the user searches.
 *
 * @class SearchEventList
 * @memberof Mojito.Applications.Sports.Search
 */

/**
 * `SearchEventList` prop types.
 *
 * @property {Array<object>} cardInfos - Promotion card infos (card id, event id, market id) to render.
 * @property {string} title - Section title.
 * @property {boolean} [pending = false] - Flag indicating that the events are being loaded.
 * @property {boolean} [isSearchResult = false] - Flag indicating that the items are search results rather than main events.
 * @property {boolean} [shouldRequestData = true] - Flag indicating whether each item should request its own event and market data. Set to false when a parent already subscribes to the same events and markets, for example through a chunk request, to avoid duplicate traffic.
 * @property {string} [emptyText = ''] - Message shown when there is nothing to render.
 * @property {Function} [onNavigate] - Called after the user triggers navigation from an event.
 *
 * @memberof Mojito.Applications.Sports.Search.SearchEventList
 */
const propTypes = {
    cardInfos: PropTypes.arrayOf(PropTypes.object).isRequired,
    title: PropTypes.string.isRequired,
    pending: PropTypes.bool,
    isSearchResult: PropTypes.bool,
    shouldRequestData: PropTypes.bool,
    emptyText: PropTypes.string,
    onNavigate: PropTypes.func,
};

const defaultProps = {
    pending: false,
    isSearchResult: false,
    shouldRequestData: true,
    emptyText: '',
    onNavigate: noop,
};

export default UIView('SearchEventList', SearchEventListImpl, propTypes, defaultProps);
